const config = {
  baseUrl: {
    dev: '/api',
    pro: ''
  },
  publicPath: process.env.VUE_APP_BASE_URL || '/'
}

module.exports = config
